// Which documents-table columns start HIDDEN for a company whose ONLY product
// is Lao TaxRIS.
//
// Every column in the "ซ่อน" menu is visible by default, which is right for a
// Thai eTax company and wrong for these two: both describe the signed Thai
// XML/PDF, and a Lao document never has one — it is filed to the MoF gateway and
// its PDF is rendered on demand, so @TimeSignedXml / @SignedXmlUrl /
// @SignedPdfUrl / @BuyerEmail are never written. Measured on the Lao test
// company: 0 of 19 documents carried any of them, against 19 of 19 for every
// other column in that menu. A column empty on every row is not information.
//
// LAO-ONLY is the condition, not "holds the Lao product". isEtax and isLaoTaxRis
// are independent flags and a company may hold both; that company has real signed
// XML and PDF for its Thai documents on this same page, so hiding the columns
// would take away something it pays for. The rule mirrors showThaiEtaxTools() in
// documents/table.vue, which hides the Thai toolbar on exactly the same test.
//
// This is a PRODUCT-level default, not a per-company preference, which is why it
// is a constant rather than Settings/laoEtax configuration like extraColumns:
// there is nothing for a customer to choose, since the fields cannot be filled
// for a Lao-only company at all. And it is only a default — both columns stay in
// the "ซ่อน" menu, so anyone who wants them can switch them back on.
//
// Lives out here rather than in table.vue so it can be unit-tested: a .vue file
// in this app cannot be (vue-jest 3.0.7 fails on its templates).
export const LAO_DEFAULT_HIDDEN_COLUMNS = ["@TimeSignedXml", "xmlAndEmail"];

function isDefaultHidden(key) {
  return LAO_DEFAULT_HIDDEN_COLUMNS.indexOf(key) !== -1;
}

/**
 * Apply the Lao default to a list of columns that are currently SHOWN.
 *
 * The table's list is a visible-set — showColumn() tests membership — so
 * "hidden by default" means leaving the key out of it.
 *
 * Both directions matter because one component serves whichever company the
 * user switches to next: without the restore, visiting a Lao-only company and
 * then a Thai one would leave the Thai company missing two columns it has every
 * right to see. Restoring appends, so a key the user had already turned back on
 * is not duplicated, and the relative order of untouched keys is preserved.
 *
 * @param {string[]} visibleKeys columns currently shown
 * @param {boolean} isLaoOnly    true only when Lao TaxRIS is the company's sole
 *                               product; false for Thai eTax and for a company
 *                               holding both
 * @returns {string[]} a new list; the input is not modified
 */
export function applyLaoHiddenDefaults(visibleKeys, isLaoOnly) {
  const list = Array.isArray(visibleKeys) ? visibleKeys : [];
  if (isLaoOnly) return list.filter((key) => !isDefaultHidden(key));

  const out = list.slice();
  LAO_DEFAULT_HIDDEN_COLUMNS.forEach((key) => {
    if (out.indexOf(key) === -1) out.push(key);
  });
  return out;
}

export default {
  LAO_DEFAULT_HIDDEN_COLUMNS,
  applyLaoHiddenDefaults,
};
